import {
  LAYOUT_COMPONENT_TYPE,
  REGISTRY_BLOCK,
  writeUtilityDismissible,
  writeUtilityItems,
  type LayoutBlock,
} from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

const UTILITY_ITEMS_SEED = writeUtilityItems([
  { id: 'util-social', kind: 'social' },
  { id: 'util-phone', kind: 'phone', icon: 'Phone' },
  { id: 'util-email', kind: 'email', icon: 'Mail' },
  { id: 'util-address', kind: 'address', icon: 'MapPin' },
]);

export const backToTopCornerDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.backToTop,
  componentType: LAYOUT_COMPONENT_TYPE.backToTopFloat,
  registryBlockKey: REGISTRY_BLOCK.presentation.backToTopCorner,
  pageId: null,
  content: {
    buttonLabel: loc3('Nach oben', 'Back to top', 'Lên đầu trang'),
    ariaLabel: loc3('Zum Seitenanfang', 'Back to top of page', 'Về đầu trang'),
    sectionIcon: loc3('ArrowUp', 'ArrowUp', 'ArrowUp'),
  },
  media: {},
  displayOrder: 101,
  /** Product default — owners opt in via Zone 4 Visibility. */
  hidden: true,
};

export const backToTopPillDefault: LayoutBlock = {
  ...backToTopCornerDefault,
  blockId: FIXTURE_BLOCK_IDS.backToTopPill,
  registryBlockKey: REGISTRY_BLOCK.presentation.backToTopPill,
};

export const contactChannelsRailDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.contactChannels,
  componentType: LAYOUT_COMPONENT_TYPE.contactChannelsFloat,
  registryBlockKey: REGISTRY_BLOCK.presentation.contactChannelsRail,
  pageId: null,
  content: {
    phone: loc3('+49 30 12345678', '+49 30 12345678', '+49 30 12345678'),
    phoneIcon: loc3('Phone', 'Phone', 'Phone'),
    fabIcon: loc3('MessagesSquare', 'MessagesSquare', 'MessagesSquare'),
    expandLabel: loc3('Kontakt öffnen', 'Open contact', 'Mở liên hệ'),
    socialInstagram: loc3(
      'https://www.instagram.com/example',
      'https://www.instagram.com/example',
      'https://www.instagram.com/example',
    ),
    socialFacebook: loc3(
      'https://www.facebook.com/example',
      'https://www.facebook.com/example',
      'https://www.facebook.com/example',
    ),
  },
  media: {},
  displayOrder: 100,
  /** Product default — owners opt in via Zone 4 Visibility. */
  hidden: true,
};

export const contactChannelsFabDefault: LayoutBlock = {
  ...contactChannelsRailDefault,
  blockId: FIXTURE_BLOCK_IDS.contactChannelsFab,
  registryBlockKey: REGISTRY_BLOCK.presentation.contactChannelsFab,
};

export const utilityBarStickyDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.utilityBar,
  componentType: LAYOUT_COMPONENT_TYPE.utilityBar,
  registryBlockKey: REGISTRY_BLOCK.presentation.utilityBarSticky,
  pageId: null,
  content: {
    utilityItems: loc3(UTILITY_ITEMS_SEED, UTILITY_ITEMS_SEED, UTILITY_ITEMS_SEED),
    dismissible: loc3(
      writeUtilityDismissible(false),
      writeUtilityDismissible(false),
      writeUtilityDismissible(false),
    ),
    rotateMs: loc3('4000', '4000', '4000'),
    phone: loc3('+49 30 12345678', '+49 30 12345678', '+49 30 12345678'),
    email: loc3('hello@example.com', 'hello@example.com', 'hello@example.com'),
    address: loc3(
      'Musterstraße 1, 10115 Berlin',
      'Musterstraße 1, 10115 Berlin',
      'Musterstraße 1, 10115 Berlin',
    ),
    socialInstagram: loc3(
      'https://www.instagram.com/example',
      'https://www.instagram.com/example',
      'https://www.instagram.com/example',
    ),
  },
  media: {},
  displayOrder: -1,
  /** Product default — owners opt in via Zone 4 Visibility. */
  hidden: true,
};

export const utilityBarStaticDefault: LayoutBlock = {
  ...utilityBarStickyDefault,
  blockId: FIXTURE_BLOCK_IDS.utilityBarStatic,
  registryBlockKey: REGISTRY_BLOCK.presentation.utilityBarStatic,
};

export const utilityBarCarouselDefault: LayoutBlock = {
  ...utilityBarStickyDefault,
  blockId: FIXTURE_BLOCK_IDS.utilityBarCarousel,
  registryBlockKey: REGISTRY_BLOCK.presentation.utilityBarCarousel,
};

export const utilityBarCollapseDefault: LayoutBlock = {
  ...utilityBarStickyDefault,
  blockId: FIXTURE_BLOCK_IDS.utilityBarCollapse,
  registryBlockKey: REGISTRY_BLOCK.presentation.utilityBarCollapse,
};
